import $ from "jquery";
import {gsap} from "gsap/all";

export class Gradient {

  constructor(el) {
    this.$el = $(el);
    this.tl = null;

    this.circleTl = null;

    this.baseSize = 518;

    this.currentSize = this.baseSize;

    this.naturalTop = this.$el.offset().top;
  }

  _scaleFactorFor(targetSize) {
    return targetSize / this.baseSize;
  }

  followCirclePath(radius = 150, duration = 8, entryDuration = 1) {
    this.stopCirclePath();

    const colors = [
      {el: this.$el.find('.color1')[0], angle: 0, direction: -1},
      {el: this.$el.find('.color2')[0], angle: (Math.PI * 2) / 3, direction: 1},
      {el: this.$el.find('.color3')[0], angle: (Math.PI * 4) / 3, direction: -1},
    ];

    this.circleTl = gsap.timeline();

    colors.forEach(({el, angle, direction}) => {
      if (!el) return;

      const proxy = {angle};

      const targetX = Math.cos(angle) * radius;
      const targetY = Math.sin(angle) * radius;

      const currentX = parseFloat(gsap.getProperty(el, "--float-x")) || 0;
      const currentY = parseFloat(gsap.getProperty(el, "--float-y")) || 0;

      this.circleTl.fromTo(el, {
        "--float-x": `${currentX}px`,
        "--float-y": `${currentY}px`,
      }, {
        "--float-x": `${targetX}px`,
        "--float-y": `${targetY}px`,
        duration: entryDuration,
        ease: "power2.inOut",
      }, 0);

      this.circleTl.to(proxy, {
        angle: angle + direction * Math.PI * 2,
        duration,
        ease: "none",
        repeat: -1,
        onUpdate: () => {
          gsap.set(el, {
            "--float-x": `${Math.cos(proxy.angle) * radius}px`,
            "--float-y": `${Math.sin(proxy.angle) * radius}px`,
          });
        },
      }, entryDuration);
    });

    return this.circleTl;
  }

  stopCirclePath() {
    if (this.circleTl) {
      this.circleTl.kill();
      this.circleTl = null;
    }
  }

  resetCirclePath(duration = 2, ease = "power2.inOut") {
    this.stopCirclePath();

    const colors = [
      {el: this.$el.find('.color1')[0], angle: 0},
      {el: this.$el.find('.color2')[0], angle: (Math.PI * 2) / 3},
      {el: this.$el.find('.color3')[0], angle: (Math.PI * 4) / 3},
    ];

    colors.forEach(({el, angle}) => {
      if (!el) return;

      gsap.to(el, {
        duration,
        ease,
        "--float-x": "0px",
        "--float-y": "0px",
      });

      el._floatAngle = angle;
    });
  }

  goToInitial() {
    this.tl = gsap.timeline({});

    const targetSize = this.baseSize; // 518
    const scaleFactor = this._scaleFactorFor(targetSize);

    this.tl.to(this.$el, {
      duration: 1,
      y: 0,
      scale: scaleFactor,
      filter: "blur(130px)",
      ease: "power2.inOut"
    });

    this.followCirclePath(110, 8, 1);

    this.currentSize = targetSize;
    return this.tl;
  }

  goToCenter() {
    this.tl = gsap.timeline({});

    const targetSize = 810;
    const scaleFactor = this._scaleFactorFor(targetSize);

    this.tl.to(this.$el, {
      duration: 1,
      y: "120px",
      scale: scaleFactor,
      filter: "blur(120px)",
      ease: "power2.inOut"
    });

    this.colorPosition({
      '.color1': {right: 0, bottom: 0, top:"unset"},
      '.color2': {top: 0},
      '.color3': {left: 0, top: 0},
    }, 2, "power2.inOut");

    this.tl.call(() => {
      this.followCirclePath(110, 12, 1.5);
    }, null, 3);

    this.currentSize = targetSize;
    return this.tl;
  }

  goToBottom() {
    this.tl = gsap.timeline({});
    const targetSize = 873;
    const scaleFactor = this._scaleFactorFor(targetSize);

    const targetY = window.innerHeight - (targetSize) / 2 + 300;
    const startY = this.naturalTop;
    const deltaY = targetY - startY;

    this.tl.to(this.$el, {
      duration: 2,
      y: deltaY,
      scale: scaleFactor,
      filter: "blur(90px)",
      ease: "power2.inOut"
    });

    this.colorPosition({
      '.color1': {right: 0, top: 100},
      '.color2': {top: 80},
      '.color3': {left: 0, top: 100},
    }, 2, "power2.inOut");

    this.resetCirclePath(2, "power2.inOut");

    this.currentSize = targetSize;
    return this.tl;
  }

  colorPosition(values = {}, duration = 2, ease = "power2.inOut") {
    Object.entries(values).forEach(([selector, props = {}]) => {
      const el = this.$el.find(selector)[0];
      if (!el) return;

      gsap.to(el, {
        duration,
        ease,
        ...props,
      });
    });
  }

  reset() {

    this.stopCirclePath();
    this.resetCirclePath(2, "power2.inOut");

    if (this.tl) {
      this.tl.kill();
      this.tl = null;
    }

    return this.goToInitial();
  }
}
